// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%236c757d%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* started Reportbuild design */

.Reportbuild-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: space-between;
  /* it will give space between header and footer */

}

.contentReportbuild {
  flex: 1 1;
  padding-bottom: 10px;
  /* Adjust as needed to leave space for the footer */
}


.Reportbuild-container {
  background-color: #eaeaeb;
  /*page background color*/
}

.contentReportbuild {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  /* Adjust this to 'center' if you want content centered vertically */
  min-height: 40vh;
  /* Ensures the container takes at least the full viewport height */

}

.button {
  background-color: #ccc;
  /* Default background color */
  padding: 2px 20px;
  /* Adjust padding as needed */
  margin: 0 10px;
  /* Adjust margin as needed */
}

.custom-dropdown-button .dropdown-toggle {
  font-size: 13px !important;
}

 button#dropdown-custom-download {
  background-color: #366872;
  color: #fff;
  border: #366872;
 font-size: 13px;
} 

/*
button#dropdown-custom-download {
  background-color:var(--download-btn-bg-color);
  color:var(--download-btn-txt-color);
  font-size: 12px;
}
*/



/* below code for comparison report */

button#Generate-Report-btn-color{
  background-color: var(--ScanandPreview-btn-bg-color);
  color: var(--Scanandpreview-btn-txt-color);
  box-shadow: var(--button-box-shadow);
  font-size: 12px;
   }

/* Add to your stylesheet */
.bg-danger-soft {
  background-color: rgba(220, 53, 69, 0.08);
}
.bg-success-soft {
  background-color: rgba(40, 167, 69, 0.08);
}


/* cards automatically adjust if we add third card */
@media (max-width: 992px) {
  .row.justify-content-center {
    max-width: 100%;
  }
}
@media (max-width: 576px) {
  .card {
    width: 100% !important;
  }
}


/* Modal popup styles */

/* .modal-content {
  border-radius: 12px;
  border: none;
  box-shadow: 0 5px 20px rgba(0,0,0,0.2);
}
.modal-header {
  border-bottom: 1px solid #eee;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px 12px 0 0;
}
.modal-title {
  font-weight: 600;
}
.table th {
  font-weight: 600;
  background-color: #f8f9fa;
}
.table td, .table th {
  vertical-align: middle;
  padding: 0.75rem;
} */

/* Custom dropdown styling to match exactly */
.unified-dropdown {
  background-color: #fff !important;
  border: 1px solid #ced4da !important;
  color: #212529 !important;
  font-size: 13px !important;
  padding: 0.25rem 1.5rem 0.25rem 0.5rem !important;
  border-radius: 0.25rem !important;
  cursor: pointer !important;
  text-align: left !important;
  width: 100% !important;
  appearance: none !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  background-repeat: no-repeat !important;
  background-position: right 0.5rem center !important;
  background-size: 16px 12px !important;
}

.unified-dropdown:hover {
  background-color: #f8f9fa !important;
}

/* For React-Bootstrap Dropdown */
.custom-dropdown-toggle::after {
  display: none !important; /* Hide default caret */
}`, "",{"version":3,"sources":["webpack://./src/assets/css/gapsycaudit.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,8BAA8B;EAC9B,iDAAiD;;AAEnD;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,mDAAmD;AACrD;;;AAGA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,oEAAoE;EACpE,gBAAgB;EAChB,kEAAkE;;AAEpE;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;CAEC;EACC,yBAAyB;EACzB,WAAW;EACX,eAAe;CAChB,eAAe;AAChB;;AAEA;;;;;;CAMC;;;;AAID,qCAAqC;;AAErC;EACE,oDAAoD;EACpD,0CAA0C;EAC1C,oCAAoC;EACpC,eAAe;GACd;;AAEH,2BAA2B;AAC3B;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;;;AAGA,oDAAoD;AACpD;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;AACF;;;AAGA,uBAAuB;;AAEvB;;;;;;;;;;;;;;;;;;;;GAoBG;;AAEH,6CAA6C;AAC7C;EACE,iCAAiC;EACjC,oCAAoC;EACpC,yBAAyB;EACzB,0BAA0B;EAC1B,iDAAiD;EACjD,iCAAiC;EACjC,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;EACtB,2BAA2B;EAC3B,oEAA4P;EAC5P,uCAAuC;EACvC,mDAAmD;EACnD,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,iCAAiC;AACjC;EACE,wBAAwB,EAAE,uBAAuB;AACnD","sourcesContent":["/* started Reportbuild design */\r\n\r\n.Reportbuild-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 100vh;\r\n  justify-content: space-between;\r\n  /* it will give space between header and footer */\r\n\r\n}\r\n\r\n.contentReportbuild {\r\n  flex: 1;\r\n  padding-bottom: 10px;\r\n  /* Adjust as needed to leave space for the footer */\r\n}\r\n\r\n\r\n.Reportbuild-container {\r\n  background-color: #eaeaeb;\r\n  /*page background color*/\r\n}\r\n\r\n.contentReportbuild {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  /* Adjust this to 'center' if you want content centered vertically */\r\n  min-height: 40vh;\r\n  /* Ensures the container takes at least the full viewport height */\r\n\r\n}\r\n\r\n.button {\r\n  background-color: #ccc;\r\n  /* Default background color */\r\n  padding: 2px 20px;\r\n  /* Adjust padding as needed */\r\n  margin: 0 10px;\r\n  /* Adjust margin as needed */\r\n}\r\n\r\n.custom-dropdown-button .dropdown-toggle {\r\n  font-size: 13px !important;\r\n}\r\n\r\n button#dropdown-custom-download {\r\n  background-color: #366872;\r\n  color: #fff;\r\n  border: #366872;\r\n font-size: 13px;\r\n} \r\n\r\n/*\r\nbutton#dropdown-custom-download {\r\n  background-color:var(--download-btn-bg-color);\r\n  color:var(--download-btn-txt-color);\r\n  font-size: 12px;\r\n}\r\n*/\r\n\r\n\r\n\r\n/* below code for comparison report */\r\n\r\nbutton#Generate-Report-btn-color{\r\n  background-color: var(--ScanandPreview-btn-bg-color);\r\n  color: var(--Scanandpreview-btn-txt-color);\r\n  box-shadow: var(--button-box-shadow);\r\n  font-size: 12px;\r\n   }\r\n\r\n/* Add to your stylesheet */\r\n.bg-danger-soft {\r\n  background-color: rgba(220, 53, 69, 0.08);\r\n}\r\n.bg-success-soft {\r\n  background-color: rgba(40, 167, 69, 0.08);\r\n}\r\n\r\n\r\n/* cards automatically adjust if we add third card */\r\n@media (max-width: 992px) {\r\n  .row.justify-content-center {\r\n    max-width: 100%;\r\n  }\r\n}\r\n@media (max-width: 576px) {\r\n  .card {\r\n    width: 100% !important;\r\n  }\r\n}\r\n\r\n\r\n/* Modal popup styles */\r\n\r\n/* .modal-content {\r\n  border-radius: 12px;\r\n  border: none;\r\n  box-shadow: 0 5px 20px rgba(0,0,0,0.2);\r\n}\r\n.modal-header {\r\n  border-bottom: 1px solid #eee;\r\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\r\n  border-radius: 12px 12px 0 0;\r\n}\r\n.modal-title {\r\n  font-weight: 600;\r\n}\r\n.table th {\r\n  font-weight: 600;\r\n  background-color: #f8f9fa;\r\n}\r\n.table td, .table th {\r\n  vertical-align: middle;\r\n  padding: 0.75rem;\r\n} */\r\n\r\n/* Custom dropdown styling to match exactly */\r\n.unified-dropdown {\r\n  background-color: #fff !important;\r\n  border: 1px solid #ced4da !important;\r\n  color: #212529 !important;\r\n  font-size: 13px !important;\r\n  padding: 0.25rem 1.5rem 0.25rem 0.5rem !important;\r\n  border-radius: 0.25rem !important;\r\n  cursor: pointer !important;\r\n  text-align: left !important;\r\n  width: 100% !important;\r\n  appearance: none !important;\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%236c757d' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\") !important;\r\n  background-repeat: no-repeat !important;\r\n  background-position: right 0.5rem center !important;\r\n  background-size: 16px 12px !important;\r\n}\r\n\r\n.unified-dropdown:hover {\r\n  background-color: #f8f9fa !important;\r\n}\r\n\r\n/* For React-Bootstrap Dropdown */\r\n.custom-dropdown-toggle::after {\r\n  display: none !important; /* Hide default caret */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
